import { values } from "lodash";
import { adminService } from "../_services/admin.service";

function get2plusByIdCumulativeCountGraph(values) {
  return adminService.get2plusByIdCumulativeCountGraph(values);
}

function get2PlusNewAropiPostBharaliCumulativeCountGraph(values) {
  return adminService.get2PlusNewAropiPostBharaliCumulativeCountGraph(values);
}

export const adminServiceAction = {
  noticeList,
  noticeCount,
  getArrestCountCityWise,
  getPreventiveActionViolators,
  getPreventiveActionViolatorsCount,
  getGunaAccusedListByDistrict,
  getGunaRegisterAdmin,
  noticeGraph,
  arrestGraph,
  gunaGraph,
  getResidentsByPoliceStation,
  getCriminalsByPoliceStationArea,
  getAccusedImageCount,
  getGunhaWithAccusedImage,
  getResidentsByPoliceStationSearch,
  getCriminalsByPoliceStationAreaSearch,
  getResidentsByPoliceStationByFilter,
  getCriminalsByPoliceStationAreaByFiter,
  getResidentsByPoliceStationByFilterExcelDownload,
  getCriminalsByPoliceStationAreaByFiterExcelDownload,
  getResidentsByPoliceStationById,
  getAccusedByIdImageCount,
  getResidentsByPoliceIdStationSearch,
  getResidentsByPoliceStationIdByFilter,
  getResidentsByPoliceStationByFilterExcelDownloadById,
  getDashboard,
  getGunhaDetailsByHeading,
  UserSnapShots,
  DistrictSnapShots,
  createHelpDeskFeedback,
  userWiseHelpDesk,
  getHelpDesk,
  getCompletedPreventiveActionsList,
  getCompletedPreventiveActionsCount,
  getOngoingPreventiveActionsList,
  getOngoingPreventiveActionsCount,
  getPreventiveActionsList,
  getPreventiveActionsCount,
  GetOnlineUserCount,
  mapCountCity,
  activeCityList,
  createSubCity,
  countCity,
  subCityList,
  ApiLogs,
  ApiLogsDetails,
  getOverallCityWiseName,
  TotalCrimeCount,
  totalCrimeList,
  RenewProvision,
  HistoryVerification,
  crimeAlbumLog,
  generateAlbumId,
  getCrimeCrimeAlbumAccessLogs,
  SuspendedVerification,
  updateMobileAddress,
  getMobileData,
  getAccusedListWithTwoOrMoreCountByDistinct,
  getAccusedListWithTwoOrMoreCountById,
  getAccusedListWithTwoOrMoreListByDistinct,
  getAccusedListWithTwoOrMoreListById,
  getCriminalDetails,
  OnlineCityWiseUserOnline,
  NewDashboard,
  AdminNewDashboard,
  get2plusNewArophiPreventiveActionCount,
  get2plusNewArophiPreventiveActionPoliceStationCount,
  get2lusArophiCountGraph,
  get2lusArophiCountGraphPoliceStation,
  get2lusNewListAropiGraph,
  get2lusNewListAropiGraphPoliceStation,
  getPreventiveActionAnalytics,
  getPreventiveActionAnalyticsList,
  get2plusByIdCountGraph,
  getDistrictPreventiveActionAnalytics,
  getDistrictPreventiveActionAnalyticsList,
  get2PlusNewAropiPostBharaliCountGraph,
  get2plusByIdCumulativeCountGraph,
  get2PlusNewAropiPostBharaliCumulativeCountGraph,
  CctvMasterDetails,
  fuzzyList,
  crimeNullList,
  aropiCountYear,
};

function noticeList(values) {
  return adminService.noticeList(values);
}
function noticeCount(values) {
  return adminService.noticeCount(values);
}
function getArrestCountCityWise(values) {
  return adminService.getArrestCountCityWise(values);
}
function getPreventiveActionViolators(values) {
  return adminService.getPreventiveActionViolators(values);
}
function getPreventiveActionViolatorsCount(values) {
  return adminService.getPreventiveActionViolatorsCount(values);
}
function getGunaAccusedListByDistrict(values) {
  return adminService.getGunaAccusedListByDistrict(values);
}
function getGunaRegisterAdmin(values) {
  return adminService.getGunaAccusedListByDistrict(values);
}
function noticeGraph(values) {
  return adminService.noticeGraph(values);
}
function arrestGraph(values) {
  return adminService.arrestGraph(values);
}
function gunaGraph(values) {
  return adminService.gunaGraph(values);
}
function getResidentsByPoliceStation(values) {
  return adminService.getResidentsByPoliceStation(values);
}
function getCriminalsByPoliceStationArea(values) {
  return adminService.getCriminalsByPoliceStationArea(values);
}
function getAccusedImageCount(values) {
  return adminService.getAccusedImageCount(values);
}
function getGunhaWithAccusedImage(value) {
  return adminService.getGunhaWithAccusedImage(value);
}
function getResidentsByPoliceStationSearch(value) {
  return adminService.getResidentsByPoliceStationSearch(value);
}
function getCriminalsByPoliceStationAreaSearch(values) {
  return adminService.getCriminalsByPoliceStationAreaSearch(values);
}
function getResidentsByPoliceStationByFilter(values) {
  return adminService.getResidentsByPoliceStationByFilter(values);
}
function getCriminalsByPoliceStationAreaByFiter(values) {
  return adminService.getCriminalsByPoliceStationAreaByFiter(values);
}
function getResidentsByPoliceStationByFilterExcelDownload(values) {
  return adminService.getResidentsByPoliceStationByFilterExcelDownload(values);
}
function getCriminalsByPoliceStationAreaByFiterExcelDownload(values) {
  return adminService.getCriminalsByPoliceStationAreaByFiterExcelDownload(
    values,
  );
}
function getResidentsByPoliceStationById(values) {
  return adminService.getResidentsByPoliceStationById(values);
}
function getAccusedByIdImageCount(values) {
  return adminService.getAccusedByIdImageCount(values);
}
function getResidentsByPoliceIdStationSearch(values) {
  return adminService.getResidentsByPoliceIdStationSearch(values);
}
function getResidentsByPoliceStationIdByFilter(values) {
  return adminService.getResidentsByPoliceStationIdByFilter(values);
}
function getResidentsByPoliceStationByFilterExcelDownloadById(values) {
  return adminService.getResidentsByPoliceStationByFilterExcelDownloadById(
    values,
  );
}
function getDashboard(values) {
  return adminService.getDashboard(values);
}
function getGunhaDetailsByHeading(values) {
  return adminService.getGunhaDetailsByHeading(values);
}
function UserSnapShots(values) {
  return adminService.UserSnapShots(values);
}
function DistrictSnapShots(values) {
  return adminService.DistrictSnapShots(values);
}
function createHelpDeskFeedback(values) {
  return adminService.createHelpDeskFeedback(values);
}
function userWiseHelpDesk(values) {
  return adminService.userWiseHelpDesk(values);
}
function getHelpDesk() {
  return adminService.getHelpDesk();
}
function getCompletedPreventiveActionsList(values) {
  return adminService.getCompletedPreventiveActionsList(values);
}
function getCompletedPreventiveActionsCount(values) {
  return adminService.getCompletedPreventiveActionsCount(values);
}
function getOngoingPreventiveActionsList(values) {
  return adminService.getOngoingPreventiveActionsList(values);
}
function getOngoingPreventiveActionsCount(values) {
  return adminService.getOngoingPreventiveActionsCount(values);
}
function getPreventiveActionsList(values) {
  return adminService.getPreventiveActionsList(values);
}
function getPreventiveActionsCount(values) {
  return adminService.getPreventiveActionsCount(values);
}
function GetOnlineUserCount(values) {
  return adminService.GetOnlineUserCount(values);
}
function mapCountCity() {
  return adminService.mapCountCity();
}
function activeCityList() {
  return adminService.activeCityList();
}
function createSubCity(values) {
  return adminService.createSubCity(values);
}
function countCity(values) {
  return adminService.countCity(values);
}
function subCityList() {
  return adminService.subCityList();
}
function mapCityList(values) {
  return adminService.mapCityList(values);
}
function ApiLogs(values) {
  return adminService.ApiLogs(values);
}
function ApiLogsDetails() {
  return adminService.ApiLogsDetails();
}
function getOverallCityWiseName(values) {
  return adminService.getOverallCityWiseName(values);
}
function TotalCrimeCount() {
  return adminService.TotalCrimeCount();
}
function totalCrimeList(values) {
  return adminService.totalCrimeList(values);
}
function RenewProvision(values) {
  return adminService.RenewProvision(values);
}
function HistoryVerification(values) {
  return adminService.HistoryVerification(values);
}
function crimeAlbumLog(values) {
  return adminService.crimeAlbumLog(values);
}
function generateAlbumId() {
  return adminService.generateAlbumId(values);
}
function getCrimeCrimeAlbumAccessLogs() {
  return adminService.getCrimeCrimeAlbumAccessLogs();
}
function SuspendedVerification() {
  return adminService.SuspendedVerification();
}
function updateMobileAddress() {
  return adminService.updateMobileAddress();
}
function getMobileData(id) {
  return adminService.getMobileData(id);
}
function getAccusedListWithTwoOrMoreCountByDistinct(values) {
  return adminService.getAccusedListWithTwoOrMoreCountByDistinct(values);
}
function getAccusedListWithTwoOrMoreCountById(values) {
  return adminService.getAccusedListWithTwoOrMoreCountById(values);
}
function getAccusedListWithTwoOrMoreListByDistinct(values) {
  return adminService.getAccusedListWithTwoOrMoreListByDistinct(values);
}
function getAccusedListWithTwoOrMoreListById(values) {
  return adminService.getAccusedListWithTwoOrMoreListById(values);
}
function getCriminalDetails(values) {
  return adminService.getCriminalDetails(values);
}
function OnlineCityWiseUserOnline(values) {
  return adminService.OnlineCityWiseUserOnline(values);
}
function NewDashboard(values) {
  return adminService.NewDashboard(values);
}
function AdminNewDashboard(values) {
  return adminService.AdminNewDashboard(values);
}
function get2plusNewArophiPreventiveActionCount(values) {
  return adminService.get2plusNewArophiPreventiveActionCount(values);
}
function get2plusNewArophiPreventiveActionPoliceStationCount(values) {
  return adminService.get2plusNewArophiPreventiveActionPoliceStationCount(
    values,
  );
}
function get2lusArophiCountGraph(values) {
  return adminService.get2lusArophiCountGraph(values);
}
function get2lusArophiCountGraphPoliceStation(values) {
  return adminService.get2lusArophiCountGraphPoliceStation(values);
}
function get2lusNewListAropiGraph(values) {
  return adminService.get2lusNewListAropiGraph(values);
}
function get2lusNewListAropiGraphPoliceStation(values) {
  return adminService.get2lusNewListAropiGraphPoliceStation(values);
}
function getPreventiveActionAnalytics(values) {
  return adminService.getPreventiveActionAnalytics(values);
}
function getPreventiveActionAnalyticsList(values) {
  return adminService.getPreventiveActionAnalyticsList(values);
}
function get2plusByIdCountGraph(values) {
  return adminService.get2plusByIdCountGraph(values);
}
function getDistrictPreventiveActionAnalytics(values) {
  return getDistrictPreventiveActionAnalytics(values);
}
function getDistrictPreventiveActionAnalyticsList(values) {
  return adminService.getDistrictPreventiveActionAnalyticsList(values);
}
function get2PlusNewAropiPostBharaliCountGraph(values) {
  return adminService.get2PlusNewAropiPostBharaliCountGraph(values);
}
function CctvMasterDetails(values) {
  return adminService.CctvMasterDetails(values);
}
function fuzzyList(values) {
  return adminService.fuzzyList(values);
}
function crimeNullList(values){
  return adminService.crimeNullList(values)
}
function aropiCountYear(values) {
  return adminService.aropiCountYear(values);
}